const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
console.log(API_BASE_URL)
const API_ROUTES = {

    
  GET_BANNERS: `${API_BASE_URL}/banners`,
  GET_MASTER_CATEGORIES: `${API_BASE_URL}/categories/master`,
    GET_CATEGORIES: `${API_BASE_URL}/categories`,   // ✅ ADD THIS
  GET_CATEGORY_DETAIL: (slug) => `${API_BASE_URL}/categories/${slug}`, // ✅ optional
  GET_MENUS: `${API_BASE_URL}/menus`,
  GET_BRANDS: `${API_BASE_URL}/brands`,
  CREATE_ENQUIRY: `${API_BASE_URL}/enquiries`,
}

export default API_ROUTES;